module.exports = __webpack_public_path__ + "static/img/female-bg-id.bf8310d5.png";